<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <mat-toolbar>
    Release {{ name$ | async }}
    <div class="spacer"></div>
    <div class="actions">
      <a mat-stroked-button [routerLink]="listRoute" [disabled]="isSubmitting$ | async">Cancel</a>
      <button type="submit" mat-stroked-button color="primary" [disabled]="isSubmitting$ | async">Release</button>
    </div>
  </mat-toolbar>
  @if (isLoading$ | async) {
    <div class="loader">
      <mat-spinner diameter="24"></mat-spinner>
    </div>
  }
  @if (showError$ | async) {
    <notification-manage-error (retry)="loadType()">
      Unable to load the notification.
    </notification-manage-error>
  }
  @if (showContent$ | async) {
    <div>
      <div class="form content spacing mat-elevation-z1">
        <h2>Subscribe Users in Their Partner's Context</h2>
        <em>
          This form allows you to subscribe users to the notification in the context of the partner they exist in the
          namespace of. That is, they will have a subscription that cause them to receive notifications for all events
          that ultimately belong to their partner id.
        </em>
        <em class="last-note">
          IMPORTANT NOTE: Users with superadmin partner personas exist outside of a namespace, so they are skipped if
          present and cannot be subscribed using this method. If you want to subscribe namespaceless users to a specific
          partner context programmatically,
          <a
            href="https://github.com/vendasta/notifications/blob/master/USAGE_GUIDE.md#automatic-action-indicated-subscriptions"
            >
            see this section of User Guide
          </a>
        </em>
        <mat-form-field class="hint">
          <input matInput formControlName="typeId" placeholder="Identifier" autocomplete="off" />
          <mat-hint>An identifier is a kebab case name that uniquely and clearly defines the notification.</mat-hint>
          @if (form.get('typeId').hasError('pattern') && !form.get('typeId').hasError('required')) {
            <mat-error>
              The identifier must be kebab case, and lowercase. Example: platform-announcement
            </mat-error>
          }
          @if (!form.get('typeId').hasError('pattern') && form.get('typeId').hasError('required')) {
            <mat-error>
              An identifier is required.
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="hint">
          <mat-label>Medium</mat-label>
          <mat-select formControlName="medium">
            @for (m of availableMediums$ | async; track m) {
              <mat-option [value]="m">
                {{ mediumToString(m) }}
              </mat-option>
            }
          </mat-select>
          <mat-hint>
            Choose a channel through which users will receive your notification. In-App refers to the notification tray in
            the navigation bar (Atlas).
          </mat-hint>
        </mat-form-field>
        <div [hidden]="files().length !== 0">
          <glxy-uploader
            #glxyUploader
            [uploadUrl]="'/fileupload/'"
            [accept]="'csv'"
            [layout]="'horizontal'"
            [maxFiles]="1"
          [hintText]="
            'A header-less CSV with one column, where each row is an IAM User ID (not a Subject ID). ' +
            'This can be acquired using BigQuery or a manual method.'
          "
            (fileUploadErrored)="onError($event)"
            (filesChanged)="onFilesChanged($event)"
          ></glxy-uploader>
        </div>
        <glxy-uploader-list
          [hidden]="files().length === 0"
          [files]="files()"
          (fileDeleted)="glxyUploader.deleteFile($event)"
        ></glxy-uploader-list>
      </div>
      @if (userIdsSet$ | async) {
        <div class="form content spacing mat-elevation-z1">
          <h2>Users</h2>
          <mat-list role="list">
            @for (user of userIds$ | async; track user; let last = $last) {
              <mat-list-item>
                <h4 mat-line>{{ user }}</h4>
                @if (!last) {
                  <mat-divider [inset]="true"></mat-divider>
                }
              </mat-list-item>
            }
          </mat-list>
        </div>
      }
    </div>
  }
</form>
